import Main from './components/main.jsx'
function App() {
  return (
    <Main />
  );
}

export default App;
